/*
import Highcharts from "highcharts";

function _generateCiiHistoryChartOptions(ratings, ciiSeries, noEffectCiiSeries, noFoulingCiiSeries, noWindCiiSeries) {
    const allSeriesValues = [
        ...ciiSeries.map(point => point[1]),
        ...noEffectCiiSeries.map(point => point[1]),
        ...noFoulingCiiSeries.map(point => point[1]),
        ...noWindCiiSeries.map(point => point[1]),
    ].filter(value => value !== null && value !== undefined)

    let minCii = 1.5
    let maxCii = 4

    if (allSeriesValues.length > 0) {
        const dataMin = Math.min(...allSeriesValues)
        const dataMax = Math.max(...allSeriesValues)
        const padding = (dataMax - dataMin) * 0.1 || 0.1

        minCii = dataMin - padding
        maxCii = dataMax + padding
    }

    if (ratings != null) {
        minCii = Math.min(minCii, ratings['aRating'] * 0.9)
        maxCii = Math.max(maxCii, ratings['dRating'] * 1.1)
    }

    return {
        chart: {
            zoomType: 'xy',
            panning: {
                enabled: true,
                type: 'xy'
            },
            panKey: 'shift'
        },
        credits: {
            enabled: false,
        },
        time: {
            useUTC: true,
        },
        title: {
            text: undefined,
        },
        tooltip: {
            shared: true,
            useHTML: true,
            formatter: function () {
                let s = `<b>${Highcharts.dateFormat('%m-%Y', this.x)}</b><br/>`
                const points = this.points || [this.point]

                points.forEach(point => {
                    s += `
                        <span style="color:${point.color}">●</span>
                        ${point.series.name}: <b>${point.y}</b>
                    `

                    if (point.series.name === "No Effect CII") {
                        s += `
                            <br/>
                            <span style="font-size:11px;color:#666;">
                                Represents the vessel's theoretical CII without fouling or wind
                            </span>
                        `
                    }

                    s += "<br/>"
                })

                return s
            }
        },
        yAxis: {
            gridLineWidth: 2,
            title: {
                text: "CO2/gTDW*mile​",
                align: "high",
                style: {
                    fontSize: "14px",
                },
            },
            labels: {
                style: {
                    fontSize: "12px",
                },
            },
            min: minCii,
            max: maxCii,
            startOnTick: false,
            endOnTick: false,
            plotLines: ratings ? [{
                color: 'black',
                width: 2,
                zIndex: 2,
                value: ratings['requiredCii'],
                dashStyle: 'longdashdot',
                label: {
                    text: `Required CII (${ratings['requiredCii']})`,
                    align: 'start',
                    verticalAlign: 'top',
                    y: -10,
                }
            }] : [],
            plotBands: ratings ? [
                {
                    color: "rgba(221, 28, 13, 0.6)",
                    from: ratings['dRating'],
                    to: 100,
                    zIndex: 1,
                },
                {
                    color: "rgba(221, 128, 13, 0.6)",
                    from: ratings['cRating'],
                    to: ratings['dRating'],
                    zIndex: 1,
                    label: {
                        text: "D Grade",
                        verticalAlign: "top",
                        align: "right",
                        y: 10,
                        x: -10,
                    },
                },
                {
                    color: "rgba(253, 219, 54, 0.6)",
                    from: ratings['bRating'],
                    to: ratings['cRating'],
                    zIndex: 1,
                    label: {
                        text: "C Grade",
                        verticalAlign: "top",
                        align: "right",
                        y: 10,
                        x: -10,
                    },
                },
                {
                    color: "rgba(174, 236, 51, 0.6)",
                    from: ratings['aRating'],
                    to: ratings['bRating'],
                    zIndex: 1,
                    label: {
                        text: "B Grade",
                        verticalAlign: "top",
                        align: "right",
                        y: 10,
                        x: -10,
                    },
                },
                {
                    color: "rgba(10, 177, 10, 0.6)",
                    from: 0,
                    to: ratings['aRating'],
                    zIndex: 1,
                    label: {
                        text: "A Grade",
                        verticalAlign: "top",
                        align: "right",
                        y: 10,
                        x: -10,
                    },
                },
            ] : [],
        },
        xAxis: {
            type: "datetime",
            labels: {
                format: "{value:%m-%Y}",
                style: {
                    fontSize: "12px",
                },
            },
            crosshair: true,
        },
        exporting: {
            enabled: false,
        },
        legend: {
            layout: "horizontal",
            align: "right",
            verticalAlign: "top",
        },
        series: [
            _generateCiiSeries('CII', ciiSeries),
            _generateCiiSeries('No Effect CII', noEffectCiiSeries),
            _generateCiiSeries('No Fouling CII', noFoulingCiiSeries),
            _generateCiiSeries('No Wind CII', noWindCiiSeries),
        ],
    }
}

function _generateCiiSeriesData(data, yDataKey) {
    if (data != null) {
        return data.map((datum) => [
            new Date(datum.startDateTime).getTime(),
            datum[yDataKey] != null ? Number(datum[yDataKey].toFixed(2)) : null
        ])
    }
    return []
}

function _generateCiiSeries(name, data) {
    return {
        id: name,
        name: name,
        type: "spline",
        data: data,

        description:
            name === "No Effect CII"
                ? "Represents the vessel's theoretical CII without fouling or wind"
                : null,

        marker: { enabled: false },
        animation: false,
        states: {
            hover: { enabled: false },
            normal: { animation: false },
            inactive: { opacity: 1 },
        },
    };
}

export { _generateCiiHistoryChartOptions, _generateCiiSeriesData, _generateCiiSeries }
*/

import Highcharts from "highcharts";

function _getSeriesStats(series) {
  if (!Array.isArray(series)) {
    return null;
  }

  const values = [];
  let lastCii = null;

  for (let i = 0; i < series.length; i++) {
    const point = series[i];

    if (point && point[1] !== null && point[1] !== undefined) {
      values.push(point[1]);
      lastCii = point[1];
    }
  }

  if (!values.length) {
    return null;
  }

  return {
    minCii: Math.min.apply(null, values),
    maxCii: Math.max.apply(null, values),
    lastCii: lastCii,
  };
}

function _generateCiiHistoryChartOptions(ratings, ciiSeries, noEffectCiiSeries, noFoulingCiiSeries, noWindCiiSeries) {
  const allSeriesValues = [
    ...ciiSeries.map((point) => point[1]),
    ...noEffectCiiSeries.map((point) => point[1]),
    ...noFoulingCiiSeries.map((point) => point[1]),
    ...noWindCiiSeries.map((point) => point[1]),
  ].filter((value) => value !== null && value !== undefined);

  let minCii, maxCii;

  if (allSeriesValues.length > 0) {
    const dataMin = Math.min(...allSeriesValues);
    const dataMax = Math.max(...allSeriesValues);
    const padding = (dataMax - dataMin) * 0.1 || 0.1;

    minCii = dataMin - padding;
    maxCii = dataMax + padding;
  }

  if (ratings !== null && ratings["requiredCii"] !== null) {
    const requiredCii = ratings["requiredCii"];
    const ciiStats = _getSeriesStats(ciiSeries);

    if (ciiStats !== null) {

      const req_coef = 4;
      const min_max_coef = 5;
      if (ciiStats.lastCii > requiredCii) {
        maxCii = min_max_coef * ratings["dRating"] - req_coef * requiredCii;
        minCii = min_max_coef * ratings["aRating"] - req_coef * requiredCii;
      }
      else {
        maxCii = min_max_coef * ratings["dRating"] - req_coef * requiredCii;
        minCii = min_max_coef * ratings["aRating"] - req_coef * requiredCii;
      }
    } else {
      minCii = Math.min(minCii, ratings["aRating"] * 0.9);
      maxCii = Math.max(maxCii, ratings["dRating"] * 1.1);
    }
  }

  return {
    chart: {
      zoomType: "xy",
      panning: {
        enabled: true,
        type: "xy"
      },
      panKey: "shift"
    },
    credits: {
      enabled: false,
    },
    time: {
      useUTC: true,
    },
    title: {
      text: undefined,
    },
    tooltip: {
      shared: true,
      useHTML: true,
      formatter: function () {
        let s = `<b>${Highcharts.dateFormat("%m-%Y", this.x)}</b><br/>`;
        const points = this.points || [this.point];

        points.forEach((point) => {
          s += `
                        <span style="color:${point.color}">●</span>
                        ${point.series.name}: <b>${point.y}</b>
                    `;

          if (point.series.name === "No Effect CII") {
            s += `
                            <br/>
                            <span style="font-size:11px;color:#666;">
                                Represents the vessel's theoretical CII without fouling or wind
                            </span>
                        `;
          }

          s += "<br/>";
        });

        return s;
      }
    },
    yAxis: {
      gridLineWidth: 2,
      title: {
        text: "CO2/gTDW*mile​",
        align: "high",
        style: {
          fontSize: "14px",
        },
      },
      labels: {
        style: {
          fontSize: "12px",
        },
      },
      min: minCii,
      max: maxCii,
      startOnTick: false,
      endOnTick: false,
      plotLines: ratings ? [{
        color: "black",
        width: 2,
        zIndex: 2,
        value: ratings["requiredCii"],
        dashStyle: "longdashdot",
        label: {
          text: `Required CII (${ratings["requiredCii"]})`,
          align: "start",
          verticalAlign: "top",
          y: -10,
        }
      }] : [],
      plotBands: ratings ? [
        {
          color: "rgba(221, 28, 13, 0.6)",
          from: ratings["dRating"],
          to: 100,
          zIndex: 1,
          label: {
            text: "E Grade",
            verticalAlign: "top",
            align: "right",
            y: 10,
            x: -10,
          },
        },
        {
          color: "rgba(221, 128, 13, 0.6)",
          from: ratings["cRating"],
          to: ratings["dRating"],
          zIndex: 1,
          label: {
            text: "D Grade",
            verticalAlign: "top",
            align: "right",
            y: 10,
            x: -10,
          },
        },
        {
          color: "rgba(253, 219, 54, 0.6)",
          from: ratings["bRating"],
          to: ratings["cRating"],
          zIndex: 1,
          label: {
            text: "C Grade",
            verticalAlign: "top",
            align: "right",
            y: 10,
            x: -10,
          },
        },
        {
          color: "rgba(174, 236, 51, 0.6)",
          from: ratings["aRating"],
          to: ratings["bRating"],
          zIndex: 1,
          label: {
            text: "B Grade",
            verticalAlign: "top",
            align: "right",
            y: 10,
            x: -10,
          },
        },
        {
          color: "rgba(10, 177, 10, 0.6)",
          from: 0,
          to: ratings["aRating"],
          zIndex: 1,
          label: {
            text: "A Grade",
            verticalAlign: "top",
            align: "right",
            y: 10,
            x: -10,
          },
        },
      ] : [],
    },
    xAxis: {
      type: "datetime",
      labels: {
        format: "{value:%m-%Y}",
        style: {
          fontSize: "12px",
        },
      },
      crosshair: true,
    },
    exporting: {
      enabled: false,
    },
    legend: {
      layout: "horizontal",
      align: "right",
      verticalAlign: "top",
    },
    series: [
      _generateCiiSeries("CII", ciiSeries),
      _generateCiiSeries("No Effect CII", noEffectCiiSeries),
      _generateCiiSeries("No Fouling CII", noFoulingCiiSeries),
      _generateCiiSeries("No Wind CII", noWindCiiSeries),
    ],
  };
}

function _generateCiiSeriesData(data, yDataKey) {
  if (data !== null) {
    return data.map((datum) => [
      new Date(datum.startDateTime).getTime(),
      datum[yDataKey] !== null ? Number(datum[yDataKey].toFixed(2)) : null
    ]);
  }
  return [];
}

function _generateCiiSeries(name, data) {
  return {
    id: name,
    name: name,
    type: "spline",
    data: data,

    description:
            name === "No Effect CII"
              ? "Represents the vessel's theoretical CII without fouling or wind"
              : null,

    marker: { enabled: false },
    animation: false,
    states: {
      hover: { enabled: false },
      normal: { animation: false },
      inactive: { opacity: 1 },
    },
  };
}

export { _generateCiiHistoryChartOptions, _generateCiiSeriesData, _generateCiiSeries };
